import { combineReducers } from 'redux';
import preAuthenticationToken from './preAuthenticationToken';
import accessToken from './accessToken';
import daysToPasswordExpiration from './daysToPasswordExpiration';

export default combineReducers({
    preAuthenticationToken,
    accessToken,
    daysToPasswordExpiration,
});

export const getPreAuthenticationToken = (state) => state.preAuthenticationToken;
export const getAccessToken = (state) => state.accessToken;
export const getDaysToPasswordExpiration = (state) => state.daysToPasswordExpiration;
